import React from 'react';
import { getRadioRecentMovementDisplay } from './radioLiveCapsuleMessages';

export default function RadioRecentMovementStrip({
  recentMovement = null,
  className = '',
  compact = false,
  surface = 'expanded_dock',
  nowMs,
}) {
  const movement = getRadioRecentMovementDisplay(recentMovement, {
    surface,
    nowMs,
  });
  if (!movement) return null;

  const records = Array.isArray(movement.records) ? movement.records.slice(0, 2) : [];
  const classes = [
    'jg-radio-recent-movement',
    compact ? 'is-compact' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} aria-label="JG Radio recent movement">
      <span className="jg-radio-recent-movement-label">{movement.label}</span>
      <strong>{movement.headline}</strong>
      {records.length ? (
        <span className="jg-radio-recent-movement-records">
          {records.map((record) => (
            <span className="jg-radio-recent-movement-chip" key={record.trackId}>
              {record.coverArtUrl ? (
                <img src={record.coverArtUrl} alt="" width="24" height="24" />
              ) : null}
              <span>
                {record.title}
                <em>{record.artistName}</em>
              </span>
            </span>
          ))}
        </span>
      ) : null}
    </div>
  );
}
